module.exports = __webpack_public_path__ + "static/media/CUYA_Web_LandingPage_CalloutPhoot_TroubleBreathing.139b20be.jpg";